import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

import { Department } from '../../models/department.model';
import { PaginatedResult } from '../../models/paginated.model';
import ColisportApiResource from './colisport-api-resource.model';

export default class DepartmentApi implements ColisportApiResource {
  readonly apiUrlPath = 'department';

  constructor(readonly httpClient: AxiosInstance) {}

  getDepartmentsByName(name: string): Promise<AxiosResponse<Department[]>> {
    return this.httpClient.get(`${this.apiUrlPath}/name/${name}`);
  }

  /**
   * Busca PAGINADA de departamentos por texto (palco /colibike, ecrã 3 scroll
   * infinito). Query params filter/page/limit; devolve o envelope PaginatedResult.
   * O AbortSignal (via useInfiniteResource) cancela páginas obsoletas. A resposta
   * traz o DepartmentDto (sem `country`) - o fetcher (departments.api.ts) adiciona
   * country: 'FR' ao normalizar para o modelo Department.
   */
  async searchDepartmentsPaginated(
    params: { filter: string; page: number; limit: number },
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<PaginatedResult<Omit<Department, 'country'>>>> {
    return this.httpClient.get(`${this.apiUrlPath}/search`, {
      ...(config ?? {}),
      params,
    });
  }

  getDepartmentsWithFilters(filter: string): Promise<AxiosResponse<Department[]>> {
    return this.httpClient.get(`${this.apiUrlPath}/find/${filter}`);
  }

  getDepartmentByPostalCodeAndName(
    name: string,
    postalCode: string,
  ): Promise<AxiosResponse<Department | null>> {
    return this.httpClient.post(`${this.apiUrlPath}/match`, {
      postalCode,
      name,
    });
  }
}
